import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { NbAuthService, NbAuthOAuth2JWTToken } from '@nebular/auth';
import { NbRoleProvider } from '@nebular/security';
import { Role } from '../enum/Role';

@Injectable()
export class RoleProvider implements NbRoleProvider {

  constructor(private authService: NbAuthService) {
  }

  getRole(): Observable<string> {
    return this.authService.onTokenChange()
      .pipe(
        map((token: NbAuthOAuth2JWTToken) => {
          return token.isValid() ? token.getAccessTokenPayload().role[0] ? token.getAccessTokenPayload().role[0] : Role.Guest : Role.Guest;
        }),
      );
  }

  getRoleMultiple(): Observable<string> {
    return this.authService.onTokenChange()
      .pipe(
        map((token: NbAuthOAuth2JWTToken) => {
          return token.isValid() ? token.getAccessTokenPayload().role ? token.getAccessTokenPayload().role : [Role.Guest] : [Role.Guest];
        }),
      );
  }
}
